var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompletedTaskPerfomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17812",
    "data-name": "Group 17812",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34707",
    "data-name": "Path 34707",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34708",
    "data-name": "Path 34708",
    d: "M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Zm0-2a8,8,0,1,0-8-8A8,8,0,0,0,12,20Zm-1-4L6.76,11.757l1.414-1.414L11,13.172l5.656-5.657,1.415,1.414Z",
    fill: "#4caf50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedTaskPerfomance);
export default __webpack_public_path__ + "static/media/completed_task_perfomance.91789b05ffcb6dff69ef1f19d95b8d5e.svg";
export { ForwardRef as ReactComponent };